module.exports = __webpack_public_path__ + "img/Rocket.f99523f2.png";